import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check, Sparkles } from 'lucide-react';
const bonuses = [{
  title: 'Guía completa de toppers',
  description: 'Sistema de rotación de 51 ingredientes seguros para tu Frenchie. Aprende qué dar, cuánto y con qué frecuencia sin riesgos digestivos.',
  image: 'https://cdn.magicpatterns.com/uploads/b654rGF2FYPwuNEnWCFbJU/BOMO_4.png',
  price: 9.97
}, {
  title: 'Calculadora de porciones y premios',
  description: 'Herramienta práctica para ajustar cantidades exactas según el peso de tu perro. Incluye tabla de premios y snacks sin exceder calorías.',
  image: 'https://cdn.magicpatterns.com/uploads/rdvLce69im4q8NWXK7DBjz/bono_2.png',
  price: 9.97
}, {
  title: 'Mantenimiento de piel, cara, orejas y patas',
  description: 'Rutina completa de 7 minutos al día con productos que ya tienes en casa. Previene infecciones, irritaciones y mal olor.',
  image: 'https://cdn.magicpatterns.com/uploads/nabcgPoHKzuQvBCxJ6hi7D/bono_1.png',
  price: 9.97
}, {
  title: 'Plan anti gases y popó perfecta',
  description: 'Guía paso a paso para estabilizar las heces de tu Frenchie en 72 horas. Incluye protocolo de emergencia y señales de alerta.',
  image: 'https://cdn.magicpatterns.com/uploads/3MF5i6uGyTzjpxhQUqhDr5/bono_3.png',
  price: 9.97
}];
const totalValue = bonuses.reduce((sum, bonus) => sum + bonus.price, 0);
const bookPrice = 19.97;
const grandTotal = totalValue + bookPrice;
const promoPrice = 9.97;
export function BonusesSection() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block mb-4" data-id="element-13">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#D946EF] text-white text-sm font-bold shadow-lg" data-id="element-14">
              <Gift className="w-4 h-4" data-id="element-15" />
              ¡GRATIS con tu compra!
            </span>
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-4" data-id="element-16">
            Bonos incluidos
          </h2>
          <p className="text-[#666666] max-w-md mx-auto" data-id="element-17">
            Material extra para que la rutina sea fácil de sostener.
          </p>
        </div>

        {/* Book Cards with Descriptions */}
        <div className="max-w-6xl mx-auto mb-16" data-id="element-18">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-19">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#FDF4FF] rounded-2xl overflow-hidden border border-[#F0ABFC]/30 shadow-lg group" data-id="element-20">
                {/* Book Image */}
                <div className="relative p-4 bg-gradient-to-b from-[#FAE8FF] to-[#FDF4FF]" data-id="element-21">
                  <div className="absolute top-3 right-3 bg-[#D946EF] text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-22">
                    GRATIS
                  </div>
                  <img src={bonus.image} alt={bonus.title} className="w-full h-48 object-contain drop-shadow-xl transform group-hover:scale-105 transition-transform duration-300" data-id="element-23" />
                </div>

                {/* Content */}
                <div className="p-5" data-id="element-24">
                  <div className="flex items-start justify-between gap-2 mb-3" data-id="element-25">
                    <h3 className="font-bold text-[#2D2D2D] text-sm leading-tight" data-id="element-26">
                      {bonus.title}
                    </h3>
                    <span className="flex-shrink-0 text-sm font-bold text-[#D946EF] line-through opacity-60" data-id="element-27">
                      ${bonus.price.toFixed(2)}
                    </span>
                  </div>
                  <p className="text-[#666666] text-xs leading-relaxed" data-id="element-28">
                    {bonus.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Total Value Box */}
        <div className="max-w-4xl mx-auto" data-id="element-29">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-r from-[#D946EF] to-[#A21CAF] rounded-2xl p-6 md:p-8 text-white text-center shadow-xl" data-id="element-30">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-31">
              <Sparkles className="w-5 h-5" data-id="element-32" />
              <span className="text-sm font-semibold uppercase tracking-wider opacity-90" data-id="element-33">
                Resumen de valor
              </span>
              <Sparkles className="w-5 h-5" data-id="element-34" />
            </div>

            {/* Price breakdown */}
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-6 max-w-sm mx-auto" data-id="element-35">
              <div className="flex justify-between items-center mb-2 text-sm" data-id="element-36">
                <span className="opacity-80" data-id="element-37">
                  Bowl Upgrade (Libro principal)
                </span>
                <span className="font-semibold" data-id="element-38">${bookPrice.toFixed(2)}</span>
              </div>
              <div className="flex justify-between items-center mb-2 text-sm" data-id="element-39">
                <span className="opacity-80" data-id="element-40">4 Bonos incluidos</span>
                <span className="font-semibold" data-id="element-41">${totalValue.toFixed(2)}</span>
              </div>
              <div className="border-t border-white/20 my-3" data-id="element-42"></div>
              <div className="flex justify-between items-center text-lg" data-id="element-43">
                <span className="font-bold" data-id="element-44">Valor Total</span>
                <span className="font-bold line-through opacity-60" data-id="element-45">
                  ${grandTotal.toFixed(2)}
                </span>
              </div>
            </div>

            {/* Promo price */}
            <div className="mb-4" data-id="element-46">
              <p className="text-white/80 text-sm mb-2" data-id="element-47">
                🎉 Precio de lanzamiento por tiempo limitado
              </p>
              <div className="flex items-center justify-center gap-3" data-id="element-48">
                <span className="text-2xl line-through opacity-50" data-id="element-49">
                  ${grandTotal.toFixed(2)}
                </span>
                <span className="text-5xl md:text-6xl font-bold text-yellow-300" data-id="element-50">
                  ${promoPrice}
                </span>
              </div>
              <p className="text-yellow-200 text-sm font-semibold mt-2" data-id="element-51">
                ¡Ahorras ${(grandTotal - promoPrice).toFixed(2)}!
              </p>
            </div>

            <p className="text-white/70 text-xs max-w-md mx-auto" data-id="element-52">
              Libro principal + 4 bonos valorados en ${totalValue.toFixed(2)}{' '}
              incluidos GRATIS
            </p>
          </motion.div>

          <div className="mt-8 text-center" data-id="element-53">
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-[#D946EF] text-white text-sm font-bold shadow-lg" data-id="element-54">
              <Check className="w-4 h-4 mr-2" data-id="element-55" />
              Todo listo para aplicar
            </span>
          </div>
        </div>
      </div>
    </section>;
}